/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AirlineDataValidationError,
    AirlineDataValidationErrorFromJSON,
    AirlineDataValidationErrorFromJSONTyped,
    AirlineDataValidationErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface UploadAirlinesResponse
 */
export interface UploadAirlinesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UploadAirlinesResponse
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UploadAirlinesResponse
     */
    waterMark?: number;
    /**
     * 
     * @type {Array<AirlineDataValidationError>}
     * @memberof UploadAirlinesResponse
     */
    errors?: Array<AirlineDataValidationError> | null;
}

export function UploadAirlinesResponseFromJSON(json: any): UploadAirlinesResponse {
    return UploadAirlinesResponseFromJSONTyped(json, false);
}

export function UploadAirlinesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadAirlinesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasErrors': !exists(json, 'hasErrors') ? undefined : json['hasErrors'],
        'waterMark': !exists(json, 'waterMark') ? undefined : json['waterMark'],
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(AirlineDataValidationErrorFromJSON)),
    };
}

export function UploadAirlinesResponseToJSON(value?: UploadAirlinesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasErrors': value.hasErrors,
        'waterMark': value.waterMark,
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(AirlineDataValidationErrorToJSON)),
    };
}


